import type { RouterOutput } from '@/config/trpc'
import type { AutomationItem } from './constants'

/** A moodboard as the automations UI needs it. Only `status === 'ready'` boards are usable sources. */
export type MoodboardLike = Pick<
  RouterOutput['moodboard']['getAll'][number],
  'id' | 'name' | 'status'
>

/** An automation's content source, hydrated with its moodboard (if it still exists). */
export type AutomationSource = { id: number; moodboard?: MoodboardLike }

export function resolveSource(
  automation: Pick<AutomationItem, 'moodboardId'>,
  moodboards: MoodboardLike[],
): AutomationSource {
  return {
    id: automation.moodboardId,
    moodboard: moodboards.find((m) => m.id === automation.moodboardId),
  }
}

export function sourceName(source: AutomationSource): string {
  return source.moodboard?.name.trim() || `Moodboard #${source.id}`
}
